import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

class Footer extends Component{

    render() {
        var d = new Date();
        const currentYear = d.getFullYear();
        return(
            <div className="white-wrap" id="footer">
                <div className="socialicons" style={{clear: "both"}}>
                    <center>
                        <a href="https://twitter.com/PManuscripts" target="_blank">
                            <img src="/images/footer/twicon.png" />
                        </a> 
                        <a href="https://www.facebook.com/proofreadingmanuscripts" target="_blank">
                            <img src="/images/footer/fbicon.png"/>
                        </a>
                    </center>
                </div>
                <div>
                    <center>
                        <h5>
                            <Link to="https://proofreadingmanuscripts.com/blog/">Proofreading Manuscripts Blog</Link>
                        </h5>
                    <h5>
                        Copyright © 2012-{currentYear} Proofreading Manuscripts | All rights reserved | <a href="https://proofreadingmanuscripts.com/privacy/"><strong>Privacy Policy</strong></a>&nbsp;&nbsp;| <a href="https://proofreadingmanuscripts.com/tos/"><strong>Terms of Service</strong></a>
                    </h5>
                    </center>
                </div> 
                <center>
                    <img src="/images/footer/v.png"/><img src="/images/footer/m.png"/><img src="/images/footer/a.png"/><img src="/images/footer/d.png"/><img src="/images/footer/p.png"/><img src="/images/footer/b1.jpg"/>
                </center>
                <center>
                    <a href="http://www.dmca.com/Protection/Status.aspx?ID=e9777e17-db53-44d7-ab42-b2805070ea47" title="DMCA.com Protection Status" className="dmca-badge"> 
                        <img src="//images.dmca.com/Badges/dmca_protected_sml_120l.png?ID=e9777e17-db53-44d7-ab42-b2805070ea47" alt="DMCA.com Protection Status"/></a>   
                        <img height="24" src="https://knowledge.digicert.com/content/dam/digicertknowledgebase/library/VERISIGN/ALL_OTHER/Frank/RapidSSL_SEAL-90x50.gif"/>
                </center>
            </div>
        )
    }
}

export default connect(
)(Footer);



// WEBPACK FOOTER //
// ./src/components/pages/Footer.js